import React from "react";
import BaseLayout from "../../templates/BaseLayout/BaseLayout";
import CourseManagerTemplate from "../../templates/courseManagerTemplate/CourseManagerTemplate";

export default function CourseManagerPage() {
    return (
        <BaseLayout currentKey="CourseManager" content={<CourseManagerTemplate />} />
    );
}